import { render } from "./Footer.vue?vue&type=template&id=23e08776&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=23e08776&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-23e08776"

export default script